import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';
import Surveys from 'components/NextconLabSurveys/Surveys';
import { useEffect } from "react";

function Survey() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Surveys/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Surveys/>
        <Footer />
      </>
    )}
    </>
  );
}

export default Survey;
